<ion-row class="component-padding-sm">
  <ion-col size="12" class="ion-text-center">
    <p class="percent" *ngIf="employmentData">{{employmentData.jobPlacement.after9months.all.allJobPlacementPercentage}}%</p>
    <p class="jobplacement">Employed and applying their coding skills within 9 months</p>
    <h3 class="dark">Nucamp Alumni are employed and using their technical skills within 9 months after graduation.</h3>
    <h4 class="stripe-subtitle">Nucamp's career services will help you get the job you want after your coding bootcamp.</h4>
  </ion-col>
</ion-row>

<ion-row class="list">
  <ion-col class="listLeftCol" size="12" size-sm="12" size-md="6" size-lg="6">
    <ion-row>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon" [icon]="faCheck"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">Build confidence in a one-on-one support session with a career advisor.</p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon" [icon]="faCheck"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">Establish a winning job search plan by taking our career development course.</p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon" [icon]="faCheck"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">Get hands-on help with polishing your resume, preparing for technical interviews, and creating a LinkedIn profile that recruiters will notice.</p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon" [icon]="faCheck"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">Stand out from the rest by participating in Nucamp's Hackathon.</p>
      </ion-col>
    </ion-row>
  </ion-col>

  <ion-col class="listRightCol" size="12" size-sm="12" size-md="6" size-lg="6">
    <ion-row>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon" [icon]="faCheck"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">Discover new opportunities with access to Nucamp's exclusive nationwide Job Board.</p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon" [icon]="faCheck"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">Get the extra tools you need to improve your job search with a free month of LinkedIn Premium.</p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon" [icon]="faCheck"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">Refresh your skills with lifetime access to course content.</p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="1" class="ion-text-right">
        <fa-icon class="icon" [icon]="faCheck"></fa-icon>
      </ion-col>
      <ion-col size="11" class="ion-text-left">
        <p class="content">Stay connected as a lifetime member of Nucamp’s large and active community network of instructors, alumni, students, and other experts.</p>
      </ion-col>
    </ion-row>
  </ion-col>
</ion-row>

<!-- <ion-row>
  <ion-col class="ion-text-center" style="margin-top: 30px;">
    <ion-button class="mdButton communitybox">Learn about our career services</ion-button>
    <span style="display:none"><a href="/careerservices">Learn about our career services</a></span>
  </ion-col>
</ion-row> -->